import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { notification } from 'antd';

// services
import * as SubscriptionService from '../../../../services/bb-api/subscription';
import type { RevenueValuesType } from '../../../../services/bb-api/subscription';

export const RevenueValues: React.FC = () => {
	const [revenueValuesToday, setRevenueValuesToday] = useState<RevenueValuesType>({ newSubs: 0, newSubsRevenue: 0, renewingSubs: 0, renewingSubsRevenue: 0 });
	const [revenueValuesYesterday, setRevenueValuesYesterday] = useState<RevenueValuesType>({ newSubs: 0, newSubsRevenue: 0, renewingSubs: 0, renewingSubsRevenue: 0 });
	const [revenueValuesCurrentMonth, setRevenueValuesCurrentMonth] = useState<RevenueValuesType>({ newSubs: 0, newSubsRevenue: 0, renewingSubs: 0, renewingSubsRevenue: 0 });
	const [startOfMonth, setStartOfMonth] = useState({ currentMonth: new Date().toISOString(), nextMonth: new Date().toISOString(), lastMonth: new Date().toISOString() });
	
	useEffect(() => {
		const calculateDates = () => { 
			const currentDate = new Date();
		
			const currentMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).toISOString();
			const nextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1).toISOString();
			const lastMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1).toISOString();
		
			setStartOfMonth({ currentMonth, nextMonth, lastMonth });
		}

		calculateDates();

		const intervalTime = 20 * 1000 // 20 seconds
		const intervalId = setInterval(calculateDates, intervalTime)
		return () => clearInterval(intervalId)
	}, [])

	useEffect(() => {
		try {
			SubscriptionService.revenueByDate(new Date().toISOString()).then(setRevenueValuesToday);
			SubscriptionService.revenueByDate(new Date(Date.now() - 24*60*60*1000).toISOString()).then(setRevenueValuesYesterday);
			SubscriptionService.revenueByMonth(startOfMonth.currentMonth, startOfMonth.nextMonth).then(setRevenueValuesCurrentMonth);
		} catch (error) {
			const message = 'Der skete en fejl';
			notification.error({ message });
		}
	}, [startOfMonth])

	return (
		<StyledContainer className='revenue-values'>
			<div className='section'>
				<h2>I DAG</h2>
				<div className='box-wrapper'>
					<div className='box'>
						<div className='counter'>
							<p className='label'>Nye</p>
							<h1>{revenueValuesToday.newSubs}</h1>
						</div>
						<div className='revenue'>
							<p className='label'>Omsætning</p>
							<h1>{revenueValuesToday.newSubsRevenue.toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} <span className='currency'>DKK</span></h1>
						</div>
					</div>

					<div className='box'>
						<div className='counter'>
							<p className='label'>Fornyelser</p>
							<h1>{revenueValuesToday.renewingSubs}</h1>
						</div>
						<div className='revenue'>
							<p className='label'>Omsætning</p>
							<h1>{revenueValuesToday.renewingSubsRevenue.toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} <span className='currency'>DKK</span></h1>
						</div>
					</div>

					<div className='box'>
						<div className='total-revenue'>
							<p className='label'>Total omsætning</p>
							<h1>{(revenueValuesToday.newSubsRevenue + revenueValuesToday.renewingSubsRevenue).toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} <span className='currency'>DKK</span></h1>
						</div>
					</div>
				</div>	
			</div>

			<div className='section'>
				<h2>I GÅR</h2>
				<div className='box-wrapper'>
					<div className='box'>
						<div className='counter'>
							<p className='label'>Nye</p>
							<h1>{revenueValuesYesterday.newSubs}</h1>
						</div>
						<div className='revenue'>
							<p className='label'>Omsætning</p>
							<h1>{revenueValuesYesterday.newSubsRevenue.toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} <span className='currency'>DKK</span></h1>
						</div>
					</div>

					<div className='box'>
						<div className='counter'>
							<p className='label'>Fornyelser</p>
							<h1>{revenueValuesYesterday.renewingSubs}</h1>
						</div>
						<div className='revenue'>
							<p className='label'>Omsætning</p>
							<h1>{revenueValuesYesterday.renewingSubsRevenue.toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} <span className='currency'>DKK</span></h1>
						</div>
					</div>

					<div className='box'>
						<div className='total-revenue'>
							<p className='label'>Total omsætning</p>
							<h1>{(revenueValuesYesterday.newSubsRevenue + revenueValuesYesterday.renewingSubsRevenue).toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} <span className='currency'>DKK</span></h1>
						</div>
					</div>
				</div>
			</div>

			<div className='section'>
				<h2>DENNE MÅNED</h2>
				<div className='box-wrapper'>
					<div className='box'>
						<div className='counter'>
							<p className='label'>Nye</p>
							<h1>{revenueValuesCurrentMonth.newSubs}</h1>
						</div>
						<div className='revenue'>
							<p className='label'>Omsætning</p>
							<h1>{revenueValuesCurrentMonth.newSubsRevenue.toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} <span className='currency'>DKK</span></h1>
						</div>
					</div>

					<div className='box'>
						<div className='counter'>
							<p className='label'>Fornyelser</p>
							<h1>{revenueValuesCurrentMonth.renewingSubs}</h1>
						</div>
						<div className='revenue'>
							<p className='label'>Omsætning</p>
							<h1>{revenueValuesCurrentMonth.renewingSubsRevenue.toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} <span className='currency'>DKK</span></h1>
						</div>
					</div>

					<div className='box'>
						<div className='total-revenue'>
							<p className='label'>Total omsætning</p>
							<h1>{(revenueValuesCurrentMonth.newSubsRevenue + revenueValuesCurrentMonth.renewingSubsRevenue).toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} <span className='currency'>DKK</span></h1>
						</div>
					</div>
				</div>	
			</div>
		</StyledContainer>
	);
};

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;

	.section {
		display: flex;
		flex-direction: column;
	}

	.box-wrapper {
		display: flex;
		flex-direction: row;
	}

	.box {
		display: flex;
		flex: 0 0 auto;
		flex-direction: row;
		background-color: rgba(31, 41, 55, 1);
		height: 180px;
		margin: 1em;
		padding: 16px 16px;
		border-radius: 12px;
		box-shadow: rgba(0,0,0,0.2) 0px 2px 8px 0px;
	}

	h1 { 
		font-size: 72px;
		font-weight: 700;
		line-height: 1em;
		color: #ffffff;
		margin: 24px 0 0 0;
	}

	h2 {
		font-size: 32px;
		line-height: 1em;
		color: #9ca3af;
		margin: 14px;
		padding: 0 48px;
	}

	.label {
		font-size: 32px;
		line-height: 1em;
		margin: 0;
		color: #9ca3af;
	}

	.currency { 
		color: #9ca3af; 
		font-size: 48px;
	}

	.counter, .revenue, .total-revenue {
		padding: 0 32px;
	}

	.counter { min-width: 200px }
	.revenue { min-width: 410px }
	.total-revenue { min-width: 450px }

	.box div + div {
		border-left: 1px solid #9ca3af;
	}

	@media (max-width: 575px) {
		.section {
			margin: 24px 0 0 0;
		}

		.box-wrapper {
			flex-direction: column;
		}

		.box {
			flex-direction: column;
			height: auto;
		}

		h1 {
			font-size: 40px;
			margin: 12px 0 0 0;
		}

		.currency {
			font-size: 24px;
		}

		.label {
			font-size: 20px;
		}

		.counter { min-width: calc(100vw - 60px); margin-bottom: 24px; }
		.revenue { min-width: calc(100vw - 60px) }
		.total-revenue { min-width: calc(100vw - 60px) }

		.box div + div {
			border-left: none;
		}
	}
`;
